<div class="d-inline-flex" ngbDropdown>
  <button class="btn btn-link text-white dropdown-no-arrow"
    id="dropdownNotifications" ngbDropdownToggle>
    <div class="d-inline-flex bell-container bell-ring">
      <i class="fa-solid fa-bell"></i>
      @if (hasNotifications) {
        <span class="bell-count" [innerText]="notificationsCount"></span>
      }
    </div>
  </button>
  <div aria-labelledby="dropdownNotifications" class="dropdown-notifications px-3" ngbDropdownMenu>
    <div class="row align-items-center">
      <div class="col">
        <h6 class="dropdown-header" translate>Notifications</h6>
      </div>
      <div class="col-auto">
        @if (hasNotifications) {
          <a style="cursor: pointer" (click)="removeAllNotifications()">
            <span class="fa-solid fa-check mr-1"></span>
            <span translate>Mark all as read</span>
          </a>
        }
      </div>
    </div>

    <div class="dropdown-divider"></div>
    <div class="scroll-container">
      @if (!hasNotifications) {
        <div class="alert alert-info text-center py-3">
          <i class="fa-solid fa-circle-info mr-2"></i>
          <span translate>There are currently no notifications.</span>
        </div>
      }
      @for (notification of notifications; track notification) {
        <div
          class="card notification notification-unread p-3 mb-2" (click)="openNotificationModal(notification)">
          <div class="row align-items-center mb-2">
            <div class="col">
              <div class="notification-mark" [ngbTooltip]="'Mark as read'|translate" container="body">
                <span class="fa-solid fa-check" (click)="removeNotification(notification)"></span>
              </div>
              <h6 class="notification-title mb-0" translate [innerHTML]="notification.subject"></h6>
            </div>
            <div class="col-auto">
              <span class="text-muted">
                <span [innerHTML]="notification.date | date:'short'"></span>
              </span>
            </div>
          </div>
          <p class="mb-0">
            <span [innerHTML]="notification.message | truncate"></span>
          </div>
        }
      </div>
    </div>
  </div>
